export function decodeBase64ToObject<T>(encodedString: string): T {
  if (!encodedString) {
    return null
  }

  const jsonString = atob(encodedString)
  const obj = JSON.parse(jsonString) as T

  return obj
}

export function encodeObjectToBase64<T>(obj: T): string {
  const jsonString = JSON.stringify(obj)
  const encodedString = btoa(jsonString)

  return encodedString
}

export async function generateHash(
  data: Record<string, unknown>
): Promise<string> {
  // 1. Convert object to JSON string
  const jsonString = JSON.stringify(data)

  // 2. Encode string to bytes (UTF-8)
  const encoder = new TextEncoder()
  const encodedData = encoder.encode(jsonString)

  // 3. Generate SHA-256 hash (returns a Promise<ArrayBuffer>)
  const hashBuffer = await crypto.subtle.digest('SHA-256', encodedData)

  // 4. Convert ArrayBuffer to hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}
